import React from 'react';
import Badge from '../../Badge';

export default () => (
  <Badge color="purple" size="primary">
    BETA
  </Badge>
);
